import { withStyles } from '@material-ui/core/styles';
import EquipmentTimeoffsList from './components/EquipmentCalendarEventsList/EquipmentCalendarEventsList';
import styles from './styles';
import { format } from 'date-fns';
import Divider from '@material-ui/core/Divider';
import { useDateSettingsFormat } from 'common/useDateSettingsFormat';
import { parseStringDate } from 'helpers/_date-helpers';

const EquipmentList = ({ classes, data }) => {
  const { dateFormat } = useDateSettingsFormat();

  return (
    <div className={classes.allUsersWrapper}>
      {data?.map((user) => {
        return (
          <>
            <div className={classes.dateItem}>{format(parseStringDate(user.date), dateFormat)}</div>
            <EquipmentTimeoffsList key={user._id} calendarEvents={user.equipmentCalendarEvents} />
            <Divider style={{ marginBottom: 10 }} />
          </>
        );
      })}
    </div>
  );
};

export default withStyles(styles)(EquipmentList);
